// extracted by mini-css-extract-plugin
export var linkTag = "styles-module--linkTag--k25aS";